import ApiClient from "../../api-client";
import { API_URL } from "../../environment";

export const getPatients = ({dispatch, token, listFilter, orgId, clinicId}) => {
    return ApiClient.get(`${API_URL}/patient/get-all-patient?listFilter=${listFilter}&orgId=${orgId}&clinicId=${clinicId}`, null, token, dispatch);
};

export const getPatientById = ({dispatch, token, id, userId}) => {
    return ApiClient.get(`${API_URL}/patient/get-patient?id=${id}&userId=${userId}`, null, token, dispatch);
};

export const updatePatientById = ({payload, dispatch, token, patientId}) => {
    return ApiClient.put(`${API_URL}/patient/update-patient?patientId=${patientId}`, payload, token, dispatch);
};


export const updatePatientProfile = ({payload, dispatch, token, patientId}) => {
    return ApiClient.put(`${API_URL}/patient/update-patient-profile?patientId=${patientId}`, payload, token, dispatch);
};

export const updatePatientArchieve = ({values, dispatch, token, patientId}) => {
    return ApiClient.put(`${API_URL}/patient/update-archieve`, values, token, dispatch);
};

export const createPatient = ({values, dispatch, token}) => {
    return ApiClient.post(`${API_URL}/patient/create-patient`, values, token, dispatch);
};

export const patientResetPassword = ({values,token,dispatch}) => {
    return ApiClient.post(`${API_URL}/auth/patient-reset-password`, values, null, dispatch);
};

export const resetPatientNewPassword = ({values,dispatch}) => {
    return ApiClient.post(`${API_URL}/auth/patient-reset-new-password`, values, null, dispatch);
};


export const patientManualPasswordChange = ({values, token, dispatch}) => {
    return ApiClient.post(`${API_URL}/auth/patient-manual-password`, values, null, dispatch);
};

export const sendInviteToPatient = ({values, token, dispatch}) => {
    return ApiClient.post(`${API_URL}/auth/send-invite`, values, null, dispatch);
};

export const deletePatientDocument = ({patientId, documentId, dispatch, token }) => {
    return ApiClient.put(`${API_URL}/patient/delete-patient-doc?patientId=${patientId}&documentId=${documentId}`, {}, token, dispatch);
};

export const uploadOrUpdateDocument = ({values, dispatch, token , patientId, documentId,uploadedBy,applicationId,type }) => {
    return ApiClient.put(`${API_URL}/document/update-patient-doc?patientId=${patientId}&documentId=${documentId}&uploadedBy=${uploadedBy}&applicationId=${applicationId}&type=${type}`, values, token, dispatch);
};

export const createBulkPatients = ({values, dispatch, token}) => {
    return ApiClient.post(`${API_URL}/patient/create-bulk-patient`, values, token, dispatch);
};

export const getPatientDocuments = ({dispatch, token, id}) => {
    return ApiClient.get(`${API_URL}/document/get-documents?patientId=${id}`, null, token, dispatch);
};

export const getPatientSchema = ({dispatch, token}) => {
    return ApiClient.get(`${API_URL}/patient/get-patient-schema`,token, dispatch);
};
